import { getAnnualReturnUsingRiskScore, WeddingGoal } from '../../../goals';
import { colorsByGoalType } from '../../../goals/colors';
import { getProgressUsingTargetAmount } from '../helpers';
import { BaseGoalConfig } from './types';

export const WEDDING: BaseGoalConfig<WeddingGoal> = {
    iconName: 'GoalMarriage',
    color: colorsByGoalType['WEDDING'].primary,
    defaultName: 'Wedding',
    getDescription: () => 'Officially off the market.',
    group: 'INVEST',
    blogLink: {
        description: 'See Plenty’s guide on weddings',
        url: 'https://www.withplenty.com/blog/wedding-bells-budgets-how-to-financially-plan-for-your-big-day',
    },
    getAnnualReturn: getAnnualReturnUsingRiskScore,
    getProgress: (config) => getProgressUsingTargetAmount(config),
};
